import {storeInstance} from '@aofl/store/dist/legacy';
import {sdoNs} from './constants-enumerate';
import {deepAssign} from '@aofl/object-utils';

const sdo = {
  namespace: sdoNs.ORG_GROUP_INFO,
  mutations: {
    init() {
      return {
        name: '',
        phone: '',
        country: 'US',
        externalId: '',
        parentId: 0,
        address: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        groupPath: '',
        is_third_party_connected: false,
        third_party_connected_group_id: 0,
        managed_by: null,
        dashboardGroups: [],
      };
    },
    setData(subState, {name, phone, country_code, external_id, parent_id, address_line_1, address_line_2, city, state, zip, path, is_third_party_connected, id, third_party_connected_group_id, managed_by, dashboard_groups}) { //eslint-disable-line
      const newState = Object.assign({}, subState, {
        id,
        name,
        phone,
        country: country_code,
        externalId: external_id,
        parentId: parent_id,
        address: address_line_1,
        address2: address_line_2,
        city,
        state,
        zip,
        groupPath: path,
        is_third_party_connected,
        third_party_connected_group_id,
        managed_by,
        dashboardGroups: dashboard_groups || []
      });

      return newState;
    }
  },
  decorators: [
    (nextState) => { // $selectedGroups
      const nextSubState = nextState[sdoNs.ORG_GROUP_INFO];
      const state = storeInstance.getState();
      const subState = state[sdoNs.ORG_GROUP_INFO];

      if (typeof nextSubState.$selectedGroups === 'undefined' ||
        nextSubState.groupPath !== subState.groupPath) {
        const $selectedGroups = [];
        if (nextSubState.groupPath) {
          const groupPathParts = nextSubState.groupPath.split('.');
          const groupInfo = state[sdoNs.SESSION].group_info;
          let found = false;
          for (let i = 0; i < groupPathParts.length; i++) {
            const groupId = parseInt(groupPathParts[i], 10);
            if (found && groupId) {
              $selectedGroups.push(groupId);
            }
            if (groupId === parseInt(groupInfo.id, 10)) {
              found = true;
            }
          }
        }
        nextState = deepAssign(nextState, sdoNs.ORG_GROUP_INFO, {
          $selectedGroups
        });
      }
      return nextState;
    }
  ]
};

storeInstance.addState(sdo);
